// src/components/LayerPanel/FeaturesTab.jsx
//
// FEATURES scope. A shell over two sub-tabs, because this tab was always two
// unrelated lists stacked on top of each other:
//
//   RRC      — shared/global static config (LAYER_GROUPS_STATIC), a tree
//   FEATURES — the org's derived vector_assets catalog, a flat list
//
// They have different sources, different shapes, and different empty states,
// so each sub-panel owns its own search and its own loading/empty copy. This
// file owns only which one is showing.
//
// Sub-tab state is local and resets when the outer tab changes, since index.jsx
// unmounts this component on tab switch. That already applied to the search box
// before the split; keeping it local keeps the two consistent.

import { useEffect, useState } from "react";

import { useLayersStore } from "../../stores/useLayersStore";
import SubTabs from "./SubTabs";
import RrcInfoPanel from "./RrcInfoPanel";
import FeatureCatalogList from "./FeatureCatalogList";

const SUB_TABS = [
  { id: "rrc", label: "RRC" },
  { id: "catalog", label: "Features" },
];

export default function FeaturesTab({ userRole = "viewer" }) {
  const [subTab, setSubTab] = useState("rrc");
  const loadFeatureCatalog = useLayersStore((s) => s.loadFeatureCatalog);

  // Ensure the derived feature catalog is loaded for the active org (resilient
  // to the renderer's mount-time load racing auth). Cheap, org-scoped query.
  //
  // Deliberately here and not in FeatureCatalogList: the fetch should fire when
  // the FEATURES tab opens, not when its sub-tab is first selected, so the list
  // is already populated by the time anyone switches to it.
  useEffect(() => { loadFeatureCatalog(); }, [loadFeatureCatalog]);

  return (
    <div className="flex flex-col">
      <SubTabs
        tabs={SUB_TABS}
        activeTab={subTab}
        onChange={setSubTab}
        ariaLabel="Feature sources"
      />

      {subTab === "rrc" && <RrcInfoPanel userRole={userRole} />}
      {subTab === "catalog" && <FeatureCatalogList />}
    </div>
  );
}
